export function onSafeBackdropClick(backdrop, closeFn) {
  if (!backdrop || typeof closeFn !== "function") return;

  let pointerStartedOnBackdrop = false;

  backdrop.addEventListener("pointerdown", (ev) => {
    pointerStartedOnBackdrop = ev.target === backdrop;
  });

  backdrop.addEventListener("click", (ev) => {
    const shouldClose = pointerStartedOnBackdrop && ev.target === backdrop;
    pointerStartedOnBackdrop = false;
    if (shouldClose) closeFn(ev);
  });
}
